import { es } from "date-fns/locale"

export const dateFnsLocales = { es }
export const dateFnsLocale = es
